export const ABOUT_ME = 'Compartilhe sua formação, experiências e habilidades com a rede da Estratégia. Você pode listar suas áreas de atuação e cursos disponíveis na plataforma.';
export const PUBLIC_PROFILE = 'Ao deixar seu perfil público, ele poderá ser visto por qualquer pessoa da rede da Estratégia.';
